import * as types from './mutation-types'

export const toggleSidebar = ({ commit }, opened) =>
    commit(types.TOGGLE_SIDEBAR, opened)

export const toggleDevice = ({ commit }, device) =>
    commit(types.TOGGLE_DEVICE, device)

export const expandMenu = ({ commit }, menuItem) => {
    if (menuItem) {
        menuItem.expanded = menuItem.expanded || false
        commit(types.EXPAND_MENU, menuItem)
    }
}

export const switchEffect = ({ commit }, effectItem) => {
    if (effectItem) {
        commit(types.SWITCH_EFFECT, effectItem)
    }
}

export const setToken = ({ commit }, token) => commit(types.SET_TOKEN, token)

export const setUser = ({ commit }, user) => commit(types.LOGIN_USER, user)

export const toggleNoMenu = ({ commit }, { menuItem, nomenu }) =>
    commit(types.TOGGLE_NO_MENU, { menuItem, nomenu })



// WEBPACK FOOTER //
// ./src/store/actions.js